<app-icon library="fontawesome"
          variant="fa-plus"
          class="icon"
          simple="true">
</app-icon>
<span class="text">{{ 'generic.buttons.create' | translate }}</span>
